module.exports = __webpack_public_path__ + "static/media/calendar.975f437e.svg";